import React, { Component } from "react";
import ReactDOM from "react-dom";

// import CommonHeader from "./Header/";

import Terms from "../../routes/screens/Common/Terms";
import Privacy from "../../routes/screens/Common/Privacy";

import AppErrors from "./AppErrors";
import JoinUs from "../../routes/screens/Auth/JoinUs";
import submitPlace from "../../lib/submitPlace";

//Components
import PreLoginHead from "./components/PreLogin/PreLoginHead";
import HowItWorks from "./components/PreLogin/HowItWorks";
import PreLoginTabbar from "./components/PreLogin/PreLoginTabbar";
import LoveLocal from "./components/PreLogin/LoveLocal";
import RestaurantOwner from "./components/PreLogin/RestaurantOwner";
import DesktopPreLogin from "./components/PreLogin/DesktopPreLogin";
import MobileFooter from "./components/PreLogin/MobileFooter";
import Cookies from "../../routes/screens/Common/Cookies";

export default class PreLogin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      privacySection: false,
      termsSection: false,
      cookiesSection: false,
      selectedTab: "howItWorks",
      joinUsSection: false,
      infoSection: false,
      errorMessage: null
    };
  }
  componentDidMount() {
    var html = document.getElementById("static");
    html.classList.add("scroll-smoth");
  }
  handleChangeTab = tabName => {
    const { selectedTab } = this.state;
    if (tabName !== selectedTab) {
      this.setState({
        selectedTab: tabName
      });
    }
  };
  handleError = errorMessage => {
    if (errorMessage === 503) {
      this.setState(() => {
        throw errorMessage;
      });
    } else {
      this.setState({ errorMessage });
    }
  };
  onSubmitPlace = async place => {
    await submitPlace(place, "list", this.handleError);
  };
  handleCloseErrorMessage = () => {
    var body = document.body;
    body.classList.remove("body-overflow");
    this.setState({ errorMessage: null });
  };
  onClickClose = status => {
    this.setState({
      [status]: false
    });
  };
  openPrivacySection = () => {
    this.setState({ privacySection: true });
  };
  openTermsSection = () => {
    this.setState({ termsSection: true });
  };
  openCookiesSection = () => {
    this.setState({ cookiesSection: true });
  };
  handleJoinUs = ({ status }) => {
    var body = document.body;
    if (status === "open") {
      body.classList.add("body-overflow");
      this.setState({
        joinUsSection: true
      });
    } else if (status === "info") {
      this.setState({
        joinUsSection: false,
        infoSection: true
      });
    } else {
      body.classList.remove("body-overflow");
      this.setState({
        joinUsSection: false,
        infoSection: false
      });
    }
  };
  render() {
    const {
      termsSection,
      privacySection,
      cookiesSection,
      selectedTab,
      infoSection,
      joinUsSection,
      errorMessage
    } = this.state;
    return (
      (termsSection && <Terms onClickClose={this.onClickClose} />) ||
      (privacySection && <Privacy onClickClose={this.onClickClose} />) ||
      (cookiesSection && <Cookies onClickClose={this.onClickClose} />) || (
        <div className="main-page pre-login">
          {/* <CommonHeader /> */}
          <PreLoginHead onSubmitPlace={this.onSubmitPlace} />

          <PreLoginTabbar
            selectedTab={selectedTab}
            handleChangeTab={this.handleChangeTab}
          />

          <div className="tab-body visible-xs">
            {(selectedTab === "howItWorks" && <HowItWorks />) || <noscript />}

            {(selectedTab === "loveLocal" && <LoveLocal />) || <noscript />}

            {(selectedTab === "joinUs" && (
              <RestaurantOwner handleJoinUs={this.handleJoinUs} />
            )) || <noscript />}
          </div>
          {(errorMessage &&
            ReactDOM.createPortal(
              <AppErrors
                message={errorMessage}
                onClickClose={this.handleCloseErrorMessage}
              />,
              document.body
            )) || <noscript />}
          {(infoSection &&
            ReactDOM.createPortal(
              <AppErrors
                message="We will endeavour to get back to you as soon as possible and help start your journey as a Local E Takeaway partner."
                title="Join Local E Community"
                onClickClose={() => this.handleJoinUs({ status: null })}
              />,
              document.body
            )) || <noscript />}
          {(joinUsSection &&
            ReactDOM.createPortal(
              <JoinUs onClose={this.handleJoinUs} />,
              document.body
            )) || <noscript />}

          <DesktopPreLogin
            selectedTab={selectedTab}
            handleJoinUs={this.handleJoinUs}
            handleChangeTab={this.handleChangeTab}
          />

          <MobileFooter
            openPrivacySection={this.openPrivacySection}
            openTermsSection={this.openTermsSection}
            openCookiesSection={this.openCookiesSection}
          />
        </div>
      )
    );
  }
}
